import { configureStore } from '@reduxjs/toolkit';
import { createEpicMiddleware } from 'redux-observable';
import * as Sentry from '@sentry/react';
// import rootReducer from '@repo/redux/reducers/rootReducer';
// import rootEpic from '@repo/redux/actions/rootEpic';
import { localStoreSync } from '@support/localStore';
import { enableBatching } from 'redux-batched-actions';
import { appAlerts } from '@repo/redux/middlewares/appAlerts';
import { syncRemoteDeviceIntegrationChangesToDesktopApp } from '@repo/redux/actions/deviceIntegrations';
import { syncUserStateToDesktopApp } from '@repo/redux/reducers/user/account';

import { logOrStashCSVUploadError } from '@repo/redux/actions/csvImport';
import { ReduxAction } from '@repo/utils/types';
import AppState from '@repo/redux/app-state';
import rootReducer from './redux/root-reducer';
import rootEpic from './redux/root-epic';
import { uiStateChangeSideEffects } from './redux/middlewares/uiStateChangeSideEffects';

// Our redux store and app history are dependent on one another, so we create
// both at once here
const initializeStore = () => {
  const epicMiddleware = createEpicMiddleware<ReduxAction, ReduxAction, AppState>();
  const store = configureStore({
    reducer: enableBatching(rootReducer),
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }).concat(
        epicMiddleware,
        appAlerts,
        localStoreSync,
        syncRemoteDeviceIntegrationChangesToDesktopApp,
        syncUserStateToDesktopApp,
        uiStateChangeSideEffects,
        logOrStashCSVUploadError,
      ),
    enhancers: (getDefaultEnhancers) =>
      getDefaultEnhancers().concat(Sentry.createReduxEnhancer({})),
  });

  epicMiddleware.run(rootEpic);
  return store;
};

export const store = initializeStore();
